"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethod = void 0;
var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["PaymentTerms"] = "pt";
  PaymentMethod["CreditCard"] = "cc";
  PaymentMethod["eCheck"] = "ec";
  PaymentMethod["Paypal"] = "pp";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));